import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { doubleToHighLow } from '../../../components/TestDetails/AIResult/DoubleToHighLow';

export function FaceResultEms({ model1Result, title }) {
  const { t } = useTranslation();
  const scoreItem = (heading, value) => {
    return (
      <Stack justifyContent="space-between" spacing={2} direction="row">
        <Typography variant="h6" component="h6">
          {heading}
        </Typography>
        <Typography variant="h6" component="h6">
          {t(value)}
        </Typography>
      </Stack>
    );
  };

  return (
    <>
      <Stack spacing={1}>
        {scoreItem('Probability of facial asymentry', doubleToHighLow(model1Result.faceScore))}
        {scoreItem('Side', model1Result.faceSide)}
        {model1Result.facePalsyType ? scoreItem('Probable facial asymetry cause', model1Result.facePalsyType) : null}
      </Stack>
    </>
  );
}
